import moment from 'moment';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default async function ExportToXL({ headers, subHeaders, data, name }) {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    const headerRow = worksheet.addRow(headers);

    headerRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFF00' }
        };
        cell.alignment = { horizontal: 'left' };
    });

    data.forEach((step, i) => {
        const stepRow = worksheet.addRow(subHeaders[i])
        stepRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '0070c0' }
            };
            cell.font = { color: { argb: 'FFFFFF' } }
        });
        step.forEach(item => {
            worksheet.addRow(Object.values(item)).eachCell(cell => {
                cell.alignment = { horizontal: 'left' }
            })
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `${name}-${moment().format('DDMMYYYY')}.xlsx`;
    saveAs(new Blob([buffer]), fileName);
}
